document.addEventListener('DOMContentLoaded', () => {
    const opener = document.getElementById('open-book-a-call');
    const inner = document.querySelector('#book-a-call .inner');
    const popupButton = document.getElementById('open-popup-call');
    const bookACall = document.getElementById('book-a-call');
    const footer = document.querySelector('.footer');

    // Toggle inner menu
    if (opener && inner) {
        opener.addEventListener('click', () => {
            inner.classList.toggle('active');
        });
    }

    // Open popup window
    if (popupButton) {
        popupButton.addEventListener('click', (e) => {
            e.preventDefault();
            const url = popupButton.getAttribute('data-url');

            // Popup window dimensions
            const width = 500;
            const height = 600;

            // Center the popup on screen
            const left = (screen.width / 2) - (width / 2);
            const top = (screen.height / 2) - (height / 2);

            // Open popup window
            window.open(
                url,
                'BookACall',
                `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
            );
        });
    }

    // Hide book-a-call when footer is visible
    if (footer && bookACall) {
        const footerObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                bookACall.classList.toggle('--hidden', entry.isIntersecting);
            });
        }, { root: null, rootMargin: '0px', threshold: 0 });
        footerObserver.observe(footer);
    }
});
